import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import Typography from '@HomaHealth/ui-component-library/lib/_patient-access-components/atoms/Typography';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

export interface AddCohortInfoProps {
  hide?: boolean;
  isEdit?: boolean;
  onClick: () => any;
}

const AddCohortInfo: React.FC<AddCohortInfoProps> = ({
  hide,
  isEdit,
  onClick,
}) => {
  // styles
  const useStyles = makeStyles()({
    root: {
      background: patientAccessTheme.palette.AIQChips?.infoBackground,
      border: '1px solid ' + patientAccessTheme.palette.grey[300],
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      height: '70px',
      width: '616px',
      padding: '10px 0px',
      whiteSpace: 'break-spaces',
    },
    clickHere: {
      textDecoration:
        'underline 2px dashed ' + patientAccessTheme.palette.primary[500],
      textUnderlineOffset: '4px',
    },
  });
  const { classes } = useStyles();

  // constants
  const constants = componentConstants.MOLECULES.ADD_COHORT_INFO;

  return hide ? (
    <></>
  ) : (
    <Grid container className={classes.root}>
      <ul style={{ margin: '0px', paddingLeft: '36px' }}>
        <li>
          <Grid container style={{ marginBottom: '8px' }}>
            <Typography
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              fontSize="12px"
              lineHeight="21.24px"
              fontType="regular"
            >
              {isEdit
                ? constants.EDIT_COHORTS_INFO
                : constants.ADD_COHORTS_INFO}
            </Typography>
            <Typography
              textColor={patientAccessTheme.palette.primary[500]}
              fontSize="12px"
              lineHeight="21.24px"
              fontType="medium"
              className={classes.clickHere}
              onClick={onClick}
              cursor="pointer"
            >
              {constants.CLICK_HERE}
            </Typography>
          </Grid>
        </li>
        <li>
          <Grid>
            <Typography
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              fontSize="12px"
              lineHeight="21.24px"
              fontType="regular"
            >
              {constants.DATA_INFO}
            </Typography>
          </Grid>
        </li>
      </ul>
    </Grid>
  );
};

export default AddCohortInfo;
